exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-main {\r\n  width: 100%;\r\n}\r\n:host ::ng-deep .ant-carousel .slick-slide {\r\n  text-align: center;\r\n  height: 160px;\r\n  line-height: 160px;\r\n  background: #364d79;\r\n  color: #fff;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n:host ::ng-deep .ant-carousel .slick-slide .slider-img {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\nh3 {\r\n  color: #fff;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/slider/slider.component.css
// module id = ../../../../../src/app/slider/slider.component.css
// module chunks = main